import { useSettings } from "../hooks";
import Modal from "./Modal";

interface OpenAiChatSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  shouldTranslateMessageToDe: boolean;
  setShouldTranslateMessageToDe: (should: boolean) => void;
}

const OpenAiChatSettingsModal: React.FC<OpenAiChatSettingsModalProps> = ({
  isOpen,
  onClose,
  shouldTranslateMessageToDe,
  setShouldTranslateMessageToDe,
}) => {
  const {
    shouldHighlightWords,
    toggleWordHighlighting,
    shouldShowInlineDefs,
    toggleShowInlineDefs,
  } = useSettings();

  return (
    <Modal isOpen={isOpen} onTriggerClose={onClose}>
      <div className="pb-2">
        <b>Settings</b>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={shouldHighlightWords}
              onChange={toggleWordHighlighting}
              className="appearance-none h-4 w-4 border border-gray-300 rounded-md checked:bg-blue-500 checked:border-transparent focus:outline-none"
            />
            <span className="ml-2 text-sm text-gray-700 w-[100px]">
              Markieren
            </span>
          </label>
        </div>
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={shouldShowInlineDefs}
              onChange={toggleShowInlineDefs}
              className="appearance-none h-4 w-4 border border-gray-300 rounded-md checked:bg-blue-500 checked:border-transparent focus:outline-none"
            />
            <span className="ml-2 text-sm text-gray-700 w-[100px]">
              Inline Defs
            </span>
          </label>
        </div>
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={shouldTranslateMessageToDe}
              onChange={() => {
                setShouldTranslateMessageToDe(!shouldTranslateMessageToDe);
              }}
              className="appearance-none h-4 w-4 border border-gray-300 rounded-md checked:bg-blue-500 checked:border-transparent focus:outline-none"
            />
            <span className="ml-2 text-sm text-gray-700 w-[100px]">
              Übersetzen
            </span>
          </label>
        </div>
      </div>
    </Modal>
  );
};

export default OpenAiChatSettingsModal;
